module.exports = __webpack_public_path__ + "static/media/recovery-cover2.fc1ba5c0.png";